"use client";
import { useMemo, useState } from 'react';
import { calculateQuickRatio } from './calculations';
import { QuickRatioValues } from './types';
import CalculatorInputs from './CalculatorInputs';
import ResultsDisplay from './ResultsDisplay';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  translations: ToolsTranslations['quickRatio'];
}

export default function QuickRatioCalculator({ translations }: Props) {
  const [values, setValues] = useState<QuickRatioValues>({
    currentAssets: 85000,
    inventory: 10000,
    currentLiabilities: 50000,
  });

  const handleValuesChange = (field: keyof QuickRatioValues, value: number) => {
    setValues(prev => ({ ...prev, [field]: value }));
  };

  const result = useMemo(() => calculateQuickRatio(values, translations), [values, translations]);

  return (
    <section id="quick-ratio-calculator" className="w-full my-12 tools">
      <div className="rounded-xl border border-gray-200 shadow-sm bg-white">
        <div className="p-6 border-b border-gray-100">
          <div>
            <h2 className="text-xl font-semibold text-blue-900">{translations.title}</h2>
            <p className="text-sm text-gray-600 mt-1">{translations.subtitle}</p>
          </div>
        </div>
        <div className="p-6 grid grid-cols-1 lg:grid-cols-2 gap-8">
          <CalculatorInputs values={values} onValuesChange={handleValuesChange} translations={translations} />
          <ResultsDisplay result={result} translations={translations} />
        </div>
      </div>
    </section>
  );
}


